import {BindWalletParam, ILoginWalletReq, ModalWithHeaderProps} from "types/types";
import {ModalWithHeader} from "ui";
import React, {useCallback, useEffect, useState} from "react";
import {getWalletInitApi, getWalletNonceApi, loginByWalletApi, toBindWalletApi} from "../../api";
import {isSuccess} from "../../api/request";
import matchlog from "../../utils/matchlog";
import {useMatch} from "../../MatchContext";
import eventManager from "../../hooks/eventManager";
import {useIntl} from "react-intl";
import {WalletModalContentV2} from "../WalletModalContent";

import {RainbowKitProvider, useConnectModal} from "@rainbow-me/rainbowkit";
import {useAccount, useChainId, useConfig, useDisconnect} from "wagmi";
import useWalletBox from "../../hooks/useWalletBox";
import {getEthersSigner} from "hooks/useEthersSigner";
import {SiweMessage} from "siwe";
import "@rainbow-me/rainbowkit/styles.css";


function WalletContent({
                           onSuccess,
                           type,
                       }: {
    onSuccess?: () => void
    type: 'login' | 'bind' | ''
}) {
    const config = useConfig();
    const {openConnectModal, connectModalOpen} = useConnectModal();
    const {address, connector, isConnected} = useAccount();
    const {disconnectAsync} = useDisconnect({config});
    const chainId = useChainId()
    const {events, login} = useMatch()
    const [inited, setInited] = useState(false)


    const {status, setStatus, error, setError, statusRef, nonce, setNonce, init} = useWalletBox({
        onInit: async ({setStatus}) => {
            setStatus('start')
        }
    })

    useEffect(() => {
        matchlog.log(`status=${status}`, `connectModalOpen=${connectModalOpen}`, `address=${address}`, `isConnected=${isConnected}`)
    }, [status, connectModalOpen, isConnected, address]);
    useEffect(() => {
        if (connectModalOpen) {
            setStatus("connecting")
            return
        }
        if (!connectModalOpen && address) {
            toLoginInWallet(address)
            return
        }
        if (!connectModalOpen && !address) {
            setStatus('start')
        }
    }, [connectModalOpen, address]);
    useEffect(() => {
        if (openConnectModal && !isConnected && !inited) {
            openConnectModal && openConnectModal()
            setInited(true)
        }
    }, [openConnectModal, inited]);
    // useAccountEffect({
    //     onDisconnect() {
    //         matchlog.log('onDisconnect')
    //         setStatus('start')
    //     },
    //     onConnect(data) {
    //         matchlog.log('onConnect',data)
    //         setStatus('connecting')
    //         toLoginInWallet(data.address)
    //     },
    // });


    // useEffect(() => {
    //     if ( status != 'start') {
    //         visible && setVisible(false)
    //     } else if(status=='start'){
    //         !visible && setVisible(true)
    //     }
    // }, [ status])


    const toLoginInWallet = async (address: string) => {
        if (statusRef.current != 'start' && statusRef.current != 'connecting') return

        try {
            if (!address) {
                throw new Error('Wallet address is empty')
            }
            setStatus('nonce')
            const res = type == 'bind' ? await getWalletInitApi({
                address,
                type: "EVM"
            }) : await getWalletNonceApi({address, type: "EVM"});

            if (!isSuccess(res)) {
                throw new Error(res.message)
            }
            setNonce(res.data.nonce)
        } catch (error: any) {
            console.error('toLoginInWallet', error)
            setStatus('error')
            setError(error.message)
        }
    }

    const signature = useCallback(async () => {
        if (!nonce || status != 'nonce') {
            return
        }
        try {
            const signer = await getEthersSigner(config);
            if (!signer) return;
            matchlog.log('signature', nonce, status)
            if (!address) {
                throw new Error('Wallet address is empty')
            }
            setStatus('signer')
            const params: ILoginWalletReq = {
                domain: window.location.host,
                address,
                statement: 'By signing, you are proving you own this wallet and logging in. This does not initiate a transaction or cost any fees.',
                uri: window.location.origin,
                nonce,
                version: "1",
                chainId,
            };
            const message = new SiweMessage({...params});
            const signature = await signer.signMessage(message.prepareMessage());
            const obj: BindWalletParam = {
                type: 'EVM',
                address: address,
                signature: signature,
                message: `${message.prepareMessage()}`,
                connector_type: connector?.type || '',
                wallet_client_type: connector?.name || '',
            }
            const res = type == 'bind' ? await toBindWalletApi(obj) : await loginByWalletApi(obj)
            if (!isSuccess(res)) {
                throw new Error(res.message)
            }

            matchlog.log(res)
            setStatus('success')
            if (type == 'bind') {
                events!.onBind && events!.onBind({
                    type: 'evm'
                })
                eventManager.emit('onBind', {
                    type: 'evm'
                })
            } else {
                await login({
                    token: `${res.data.token_type} ${res.data.access_token}`
                })
            }
            onSuccess && onSuccess()


        } catch (error: any) {
            console.error('signature', error)
            setStatus('error')
            setError(error.reason || error.message)
        }


    }, [nonce, status, address])
    useEffect(() => {
        if (signature) {
            signature()
        }
    }, [signature])

    const onError = async () => {
        if (isConnected) {
            try {
                await disconnectAsync()
            } catch (error: any) {
                console.error('disconnectAsync', error)
            }
        }

        setError('')
        setNonce(undefined)
        setStatus('start')
        openConnectModal?.()
    }
    const onConnect = async () => {
        // console.log('onConnect')
        if (isConnected) {
            try {
                await disconnectAsync()
            } catch (error: any) {
                console.error('disconnectAsync', error)
            }
        }
        setError('')
        setNonce(undefined)
        openConnectModal?.()
    }
    const onDisconnect = async () => {
        if (isConnected) {
            try {
                await disconnectAsync()
            } catch (error: any) {
                console.error('disconnectAsync', error)
            }
        }

        setError('')
        setNonce(undefined)
        setStatus('start')
    }

    return <WalletModalContentV2
        status={status}
        onSuccess={async () => onSuccess?.()}
        error={error}
        onError={onError}
        onConnect={onConnect}
        onDisconnect={onDisconnect}
    />
}

type EVMModalProps = ModalWithHeaderProps & {
    type?: 'login' | 'bind' | ''
    onSuccess?: () => void
}

function EVMConnectModal({
                             type = 'login',
                             onSuccess,
                             ...props
                         }: EVMModalProps) {
    const intl = useIntl()
    return <ModalWithHeader {...props} title={props.title || (intl.formatMessage({
        id: type == "bind" ? "bindWith" : "loginWith"
    }, {
        name: "EVM"
    }))}>
        <WalletContent onSuccess={onSuccess} type={type}/>
    </ModalWithHeader>
}

export default function EVMModal(props: EVMModalProps) {
    return props.isOpen && <RainbowKitProvider><EVMConnectModal {...props}/></RainbowKitProvider>
}